import { cn } from '../../lib/utils';
import { chatTheme as th } from '../../theme/chat';

export default function AgentPageLayout({ sidebar, header, children }) {
  return (
    <div className="h-full flex bg-white overflow-hidden">
      {/* Left panel */}
      {sidebar}

      {/* Workspace */}
      <div className="flex-1 flex flex-col min-w-0 h-full">
        {header && (
          <div className={cn(th.page.headerHeight, 'flex items-center px-4', th.page.headerBorder, 'flex-shrink-0')}>
            {header}
          </div>
        )}
        {children}
      </div>
    </div>
  );
}
